
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/navigation/Sidebar';
import BottomNav from '../components/navigation/BottomNav';
import ProfileDropdown from '../components/navigation/ProfileDropdown';
import { UserRole } from '../types';

const AdminLayout: React.FC = () => {
  return (
    <div className="min-h-dvh bg-brand-dark flex flex-col md:flex-row font-sans">
      <Sidebar role={UserRole.ADMIN} />

      <main className="flex-1 overflow-auto pb-24 md:pb-6 md:px-8 px-4 pt-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-brand-primary text-[10px] font-black uppercase tracking-[0.3em]">Nexus Terminal / Admin</h2>
            <div className="h-[1px] w-12 bg-brand-primary mt-1.5 shadow-[0_0_10px_#FFCE1B]"></div>
          </div>

          <div className="flex items-center gap-6">
            <span className="hidden sm:flex items-center gap-2 text-[9px] bg-brand-primary/10 text-brand-primary px-3 py-1.5 rounded-full border border-brand-primary/20 uppercase font-black tracking-widest animate-pulse">
              System Synchronized
            </span>
            <ProfileDropdown />
          </div>
        </div>

        <Outlet />
      </main>

      <BottomNav role={UserRole.ADMIN} />
    </div>
  );
};

export default AdminLayout;
